var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.addOns, function(addOnGroup, index) {
      return _c("div", { key: index, staticClass: "product__variation" }, [
        _c(
          "label",
          {
            staticClass: "product__variation__label",
            attrs: { for: "addon-" + index }
          },
          [_vm._v(_vm._s(addOnGroup["label"]))]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "product__variation__field select" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectedAddOns[index],
                  expression: "selectedAddOns[index]"
                }
              ],
              attrs: { id: "addon-" + index },
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.selectedAddOns,
                      index,
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  },
                  function($event) {
                    return _vm.onChange()
                  }
                ]
              }
            },
            _vm._l(addOnGroup["products"], function(addOn, i) {
              return _c(
                "option",
                { key: i, domProps: { value: addOn } },
                [
                  _vm._v("\n          " + _vm._s(addOn.name) + " "),
                  !_vm.hidePrices
                    ? [
                        _vm._v("\n            ("),
                        _c("price", {
                          attrs: {
                            "price-without-tax": addOn.prices_without_tax.price,
                            "price-with-tax": addOn.prices_with_tax.price
                          }
                        }),
                        _vm._v(")\n          ")
                      ]
                    : _vm._e()
                ],
                2
              )
            }),
            0
          )
        ])
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6161218e", { render: render, staticRenderFns: staticRenderFns })
  }
}